import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import axios from "axios";
import "../admin.css";
import { NavLink } from "react-router-dom";
import ShowMore from "react-show-more";

const RoleList = () => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [roles, setRoles] = useState({});
  const [pages, setPages] = useState({ page: 1, size: 20 });
  const [paging, setPaging] = useState(true);
  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const nextPage = () => {
    loadPaging(pages.page + 1, pages.size);
    setPages((prevState) => {
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    });
  };

  const loadPaging = async (page, size = pages.size) => {
    let user = JSON.parse(localStorage.getItem("user"));
    try {
      await axios
        .get(
          localStorage.getItem("basurl") +
            "/roles?page=" +
            page +
            "&size=" +
            size,
          {
            headers: {
              "mojo-access-tokens": user.token,
            },
          }
        )
        .then((response) => {
          setRoles(response.data);

          if (response.data.length < size) {
            setPaging(false);
          }
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  useEffect(() => {
    loadPaging(1);
  }, []);

  return (
    <>
      {getMessage()}
      <div className="mg-t-8">
        <>
          <table className="table">
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Rank</th>

              <th>Last Updated</th>
              <th>Edit</th>
            </tr>

            {roles.length ? (
              roles.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.rank}</td>
                  <td>
                    <Moment date={item.created_at} local fromNow />
                  </td>
                  <td>
                    <NavLink
                      to={`/admin/roles/update-role/${item.id}`}
                      className="mg-l-10"
                    >
                      Edit Role
                    </NavLink>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <th className="text-center alert-danger" colSpan={5}>
                  You have not added any role yet.
                </th>
              </tr>
            )}
          </table>
        </>
        <div className="card-footer tx-10 pd-y-15 bg-transparent tx-center">
          {paging ? (
            <h4 onClick={nextPage} href="#" className="pointer tx-16">
              <i className="fa fa-angle-down mg-r-5" />
              View More
            </h4>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default RoleList;
